import { ReactElement, ReactNode, SVGProps } from 'react';

export enum ChartType {
  AREA = 'area',
  LINE = 'line',
  BAR = 'bar',
}

export type ChartToggleOption = {
  value: ChartType;
  icon: ReactNode;
};

export type ChartTypeToggleOptions = ChartToggleOption[];

export type ChartConfig = {
  type: ChartType.LINE | ChartType.AREA | ChartType.BAR;
  enabled: boolean;
  name?: string;
  hide?: boolean;
  unit?: string;
  config: {
    dot?:
      | ReactElement<SVGProps<SVGElement>>
      | ((props: any) => ReactElement<SVGProps<SVGElement>>)
      | boolean;
    dataKey: string | number | ((obj: any) => any);
    barSize?: string | number;
    maxBarSize?: number;
    stroke?: string;
    strokeDasharray?: string | number;
    strokeWidth?: number;
    fill?: string;
    fillOpacity?: number;
    opacity?: number;
    type?: 'linear' | 'monotone' | 'step' | 'stepBefore' | 'stepAfter';
    name?: string;
    hide?: boolean;
    unit?: string | number;
    activeDot?:
      | ReactElement<SVGProps<SVGElement>>
      | ((props: any) => ReactElement<SVGElement>)
      | boolean;
    connectNulls?: boolean;
  };
  stripedBar?: boolean;
  hasEstimatedData?: boolean;
  stackId?: string;
  xAxisId?: number | string;
  yAxisId?: number | string;
};

export type DoublyLinkedDatapoint<T> = T & {
  prev?: T;
  next?: T;
};
